import { render } from "./ProductListPage.vue?vue&type=template&id=504d2748&scoped=true"
import script from "./ProductListPage.vue?vue&type=script&lang=js"
export * from "./ProductListPage.vue?vue&type=script&lang=js"

import "./ProductListPage.vue?vue&type=style&index=0&id=504d2748&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504d2748"]])

export default __exports__